export default "__VITE_ASSET__ed6a0e0f__"